exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv.color-alpha {\n  display: none;\n}\nul.colors {\n  display: none;\n}\n", ""]);

// exports
